import { httpClient } from "@/libs/axios";
import { TLoginRequest } from "./schema";
import { TLoginResponse, TRefreshTokenResponse } from "./type";

export const login = async (credentials: TLoginRequest): Promise<TLoginResponse> => {
  const { data } = await httpClient.post<TLoginResponse>("/auth/login", credentials);
  return data;
};

export const refreshToken = async (refreshToken: string): Promise<TRefreshTokenResponse> => {
  const { data } = await httpClient.post<TRefreshTokenResponse>("/auth/refresh", {
    refresh_token: refreshToken,
  });
  return data;
};

export const logout = async (): Promise<void> => {
  await httpClient.post("/auth/logout");
};
